import React from 'react';
import { Text as RNText, TextProps as RNTextProps, StyleSheet, TextStyle } from 'react-native';

export interface TextProps extends RNTextProps {
    variant?: 'base' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | 'xs' | 'button';
    color?: string;
    weight?: 'normal' | 'bold' | '500' | '600' | '700';
    align?: 'left' | 'center' | 'right';
    children?: React.ReactNode;
    className?: string; // Web escape hatch
}

/**
 * Text Component - Universal Typography Wrapper
 * Ensures consistent rendering of strings across Web and Native.
 */
export const Text: React.FC<TextProps> = ({
    variant = 'base',
    color,
    weight = 'normal',
    align = 'left',
    style,
    children,
    ...props
}) => {
    const computedStyle = StyleSheet.flatten([
        { textAlign: align },
        !!color ? { color } : null,
        !!weight ? { fontWeight: weight as TextStyle['fontWeight'] } : null,
        style,
    ]) as TextStyle;

    return (
        <RNText style={computedStyle} {...props}>
            {children}
        </RNText>
    );
};
